module.exports = __webpack_public_path__ + "static/media/virus.6b37f1e4.webp";